import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {authenticated, unauthenticated, userLoad} from 'gamesis-state';


@Injectable()
export class AuthEffects {
    userLoaded$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(userLoad),
                mergeMap((action) => action.user  && action.user.emailVerified === true ? of(authenticated()) : of(unauthenticated()))
            )
    );

    constructor(
        private actions$: Actions
    ) {
    }
}
